import type { FileImageUsage } from '@vedalib/editor/lib/files'
import { FileUsageTypeEnum } from '@vedalib/editor/lib/files'
import cn from 'classnames'

import Icon from 'components/uiKit/Icon'
import { t } from 'services/Translation'
import { useFileByUsage } from 'utils/files'

import mock from '../assets/imageDemo.svg'
import * as s from './AreaDropdownImage.module.scss'

interface IAreaImage {
  image: Omit<FileImageUsage, 'type'> | null
  overlay: string | null
  selected?: boolean
  label?: string
  disabled?: boolean
  badge: string
}
const AreaImage = ({ image, selected, overlay, label, disabled, badge }: IAreaImage) => {
  const file = useFileByUsage(image, FileUsageTypeEnum.image)

  return (
    <div className={s.root}>
      <div className={cn(s.imgContainer, { [s.selected]: selected, [s.disabled]: disabled })}>
        {file?.path ? (
          <>
            <img
              className={cn(s.img, { [s.empty]: !file?.path })}
              src={file?.path || mock}
              style={{ objectFit: file?.path ? image?.objectFit : 'contain' }}
            />

            <div className={s.mask} style={{ backgroundColor: overlay || undefined }} />
          </>
        ) : (
          <div className={s.emptyIcon}>
            <Icon name='otherBlock' />
          </div>
        )}
      </div>
      <div className={s.badge}>{badge}</div>
      <div className={cn(s.label, { [s.empty]: !(label || file?.name) })}>
        {label || file?.name || t('common.empty')}
      </div>
    </div>
  )
}

export default AreaImage
